import { Component, Input, OnInit,EventEmitter,Output,OnChanges } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { InputLabelPipe } from '../../../../../pipes/atyl/inputLabel.pipe'
import { FormAtylBase } from '../../../../form-atyl-base'


@Component({
	selector: 'atyl-form-input-radio',
	templateUrl: './form-input-radio.component.html',
	styleUrls: ['./form-input-radio.component.scss']
})
export class FormInputRadioComponent implements OnInit {

	@Input() forminput: FormAtylBase<any>
	@Input() group: any
	@Input() isValid: boolean
	@Input() errorMessage: any
	@Input() outline: any
	@Input() disabled: boolean

	label: string
	errorString: string

	currentCheckedValue:any = null;

	@Output() inputTyped = new EventEmitter<any>();
	
	constructor(
		private readonly inputLabelPipe: InputLabelPipe
	) {

	}

	ngOnInit(): void {
      /*console.log("FormInputRadioComponent init",this.forminput,
     this.group.get(this.forminput.ID),
     this.errorMessage);*/
		this.label = this.inputLabelPipe.transform(this.forminput)
		this.errorString = this.errorMessage && this.errorMessage[0] ? this.errorMessage[0] : ''
	}
	
	radioChanged(event: any, options: any) {
		const extraInput = document.querySelector('.inputText') as HTMLInputElement
		if (event.value === options.text) {
			extraInput.removeAttribute('disabled')
		} else {
			extraInput.setAttribute('disabled', 'true')
			extraInput.value = ''
		}
		var ev:any= {
			event: event  as Event,
			forminput:this.forminput,
			customBehaviour:this.forminput.customBehaviour,
			control:this.group.get(this.forminput.ID)
		}
		console.log("radioChanged",ev);
		this.inputTyped.emit(ev);
		
	}
	inputTextValue(event: any) {
		console.log(event.value)
	}
	
	checkState(event, el) {
		if (this.disabled)
			return;
		
	    event.preventDefault();
	    
	      if (this.group.get(this.forminput.ID).value.radio 
	      	&& this.group.get(this.forminput.ID).value.radio === el.value) {
	        el.checked = false;
	        let radoGrp:FormControl=(this.group.get(this.forminput.ID)as FormControl);
	       radoGrp.setValue({radio:"undefined"});
	      /* if (this.forminput.mendatory) {
		       radoGrp.setValidators(Validators.required);
	            radoGrp.setErrors({ required: true });
	             radoGrp.markAsDirty();
	       }*/
	      
	      } else {
	      
	         (this.group.get(this.forminput.ID)as FormControl).setValue({radio:el.value});
	        el.checked = true;
	      }
    	var ev:any= {
			event: event  as Event,
			forminput:this.forminput,
			customBehaviour:this.forminput.customBehaviour,
			control:this.group.get(this.forminput.ID)
		}
		console.log("checkState radio",ev);
		this.inputTyped.emit(ev);
    
  	}
  
  
  
}
